<template>
    <div>
        <InputDropdown ref="elemDdlProvince" :inputLbl="lbl.search.province" :errorInfo="errInfo[0]"
            v-model:inputValue="model.province" @update:inputValue="updateValues('province')" :itemList="provinceList"
            :isSubmitted="isSubmitted" :isShowError="true" />

        <InputDropdown ref="elemDdlDistrict" :inputLbl="lbl.search.district" :errorInfo="errInfo[1]"
            v-model:inputValue="model.district" @update:inputValue="updateValues('district')"
            :itemList="districtList" />

        <InputDropdown ref="elemDdlSubDistrict" :inputLbl="lbl.search.subDistrict" :errorInfo="errInfo[2]"
            v-model:inputValue="model.subDistrict" @update:inputValue="updateValues('subDistrict')"
            :itemList="subDistrictList" />
    </div>
</template>

<script>
import { FormHelper } from '@/helper/FormHelper';
import { defineComponent, inject, nextTick, onMounted, reactive, ref, unref } from 'vue';

// component
import InputDropdown from '@/components/Input/label/InputDropdown.vue';
import { useSearchService } from '../service/useSearchService';
import Utility from '@/helper/Utility';


export default defineComponent({
    props: {
        modelValue: {
            type: Object
        },
        valid: {
            type: Boolean
        },
        isSubmitted: {
            type: Boolean
        }
    },
    emits: ["update:modelValue", "update:valid", "init", "ready"],
    expose: ["clear"],
    components: {
        InputDropdown
    },
    setup: function (props, context) {
        const { lbl } = inject("LocaleStore")
        const errInfo = ref(FormHelper.genErrorInfo(3))
        const searchService = useSearchService()
        const provinceList = ref([])
        const districtList = ref([])
        const subDistrictList = ref([])

        const elemDdlProvince = ref(null)
        const elemDdlDistrict = ref(null)
        const elemDdlSubDistrict = ref(null)

        const model = ref({
            ...unref(props.modelValue)
        })

        const onChangeProvince = function () {
            // clear sub-data
            model.value.district = null
            model.value.subDistrict = null

            districtList.value = []
            subDistrictList.value = []

            nextTick(() => {
                elemDdlDistrict.value.clearSelect()
                elemDdlSubDistrict.value.clearSelect()
            })

            searchService.getDistrict(model.value.province).then((items) => {
                districtList.value = items
            })
        }

        const onChangeDistrict = function () {
            if (Utility.isEmptyStr(model.value.district)) {
                return // do nothing
            }

            // clear sub-data
            model.value.subDistrict = null
            subDistrictList.value = []

            nextTick(() => {
                elemDdlSubDistrict.value.clearSelect()
            })

            searchService.getSubDistrict(model.value.province, model.value.district).then((items) => {
                subDistrictList.value = items
            })
        }

        const updateValues = function (source) {
            // console.log(model.value)
            // console.log(source)
            if (source == 'province') {
                onChangeProvince()
            } else if (source == 'district') {
                onChangeDistrict()
            }

            let obj = unref(props.modelValue)
            obj.province = model.value.province
            obj.district = model.value.district
            obj.subDistrict = model.value.subDistrict

            context.emit("update:modelValue", reactive(obj))

            // validate
            validate()
        }

        const validate = function () {
            if (FormHelper.validate(errInfo.value)) {
                context.emit("update:valid", true)
            } else {
                context.emit("update:valid", false)
            }
        }

        const initComp = function () {
            // get province as default
            searchService.getProvinceList().then((items) => {
                provinceList.value = items

                // if province is selected then fetch district and set value
                if (!Utility.isEmptyObject(model.value.province)) {
                    searchService.getDistrict(model.value.province).then((items) => {
                        districtList.value = items

                        // if district is selected then fetch sub-district and set value
                        if (!Utility.isEmptyStr(model.value.district)) {
                            elemDdlDistrict.value.setValue(model.value.district)
                            
                            searchService.getSubDistrict(model.value.province, model.value.district).then((itemsSubDistrict) => {
                                subDistrictList.value = itemsSubDistrict

                                if (!Utility.isEmptyObject(model.value.province)) {
                                    elemDdlSubDistrict.value.setValue(model.value.subDistrict)
                                }
                            })
                        }
                    })
                }
                context.emit("ready")
            }).then(() => {
                validate()
            })
        }

        const clear = function () {
            // model.value = new SearchModel()

            // elemDdlProvince.value.clearSelect()
            // elemDdlDistrict.value.clearSelect()
            // elemDdlSubDistrict.value.clearSelect()
        }

        context.expose({
            clear
        })

        onMounted(() => {
            context.emit("init")

            initComp()
        })

        return {
            lbl,
            errInfo,
            model,
            provinceList,
            districtList,
            subDistrictList,
            elemDdlProvince,
            elemDdlDistrict,
            elemDdlSubDistrict,
            updateValues,
            clear
        }
    },
})
</script>

